import { Injectable } from '@angular/core';
import { Anlagentyp } from '../../domain/model/anlagentyp';

@Injectable({
    providedIn: 'root',
})
export class AnlagentypIconService {

    public static readonly DEFAULT_ICON = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_OTHERTYPES = 'innogy_picto_lightning_n_RGB.png';
    public static readonly ICON_WATER = 'innogy_picto_waterdrop_n_RGB.png';
    public static readonly ICON_WIND = 'innogy_picto_windmill_n_RGB.png';
    public static readonly ICON_BHKW = 'innogy_picto_business_small_n_RGB.png';
    public static readonly ICON_PHOTOVOLTAIC = 'innogy_picto_sun_n_RGB.png';
    public static readonly ICON_BIO = 'innogy_picto_leaf_n_RGB.png';

    public static readonly ABKUERZUNG_TO_ICON = {
        // other types
        'sons': AnlagentypIconService.ICON_OTHERTYPES,
        'müll': AnlagentypIconService.ICON_OTHERTYPES,
        'spitz': AnlagentypIconService.ICON_OTHERTYPES,
        'konv': AnlagentypIconService.ICON_OTHERTYPES,

        // water
        'wasm': AnlagentypIconService.ICON_WATER,
        'waso': AnlagentypIconService.ICON_WATER,

        // bio and geo
        'bio': AnlagentypIconService.ICON_BIO,
        'biom': AnlagentypIconService.ICON_BIO,
        'bio/d': AnlagentypIconService.ICON_BIO,
        'geo': AnlagentypIconService.ICON_BIO,

        // wind
        'wind': AnlagentypIconService.ICON_WIND,

        // bhkw / ikw
        'bhkw': AnlagentypIconService.ICON_BHKW,
        'kwk': AnlagentypIconService.ICON_BHKW,
        'ikw': AnlagentypIconService.ICON_BHKW,

        // Photovoltaic
        'pvk': AnlagentypIconService.ICON_PHOTOVOLTAIC,
        'pv': AnlagentypIconService.ICON_PHOTOVOLTAIC,
    };

    public getIconNameForAnlagentyp(anlagentyp: Anlagentyp): string {
        if (anlagentyp && anlagentyp.abkuerzung) {
            const abkuerzungLower = anlagentyp.abkuerzung.toLocaleLowerCase();
            const iconPath = AnlagentypIconService.ABKUERZUNG_TO_ICON[abkuerzungLower];
            if (iconPath) {
                return iconPath;
            }
        }

        return AnlagentypIconService.DEFAULT_ICON;
    }
}
